import axios from 'axios';

async function VerificarSocioCredencial(dniSocio: string, fchNacimiento: string) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/verificar_socio_credencial"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "socio": {
                "dni": dniSocio,
                "fchnac": fchNacimiento
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default VerificarSocioCredencial;